<via-control-panel
  [isMockData]="!isLiveData"
  [isEditMode]="isEditMode"
  [allowMockData]="allowMockData"
  (mockDataToggled)="onMockDataToggled($event)"
  (editModeToggled)="onEditModeToggled($event)"
  (showConfig)="showWidgetSelection()">
</via-control-panel>

@if (isLoading) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <via-grid
    [enabledWidgets]="enabledWidgets"
    [isLiveData]="isLiveData"
    [isEditMode]="isEditMode"
    (saveWidgetStates)="saveWidgetStates($event)"
    (widgetDisabled)="onWidgetDisabled($event)">
  </via-grid>
}
